
<div class="sidebar-menu" 
     #menu 
     role="dialog" 
     aria-modal="true" 
     [attr.aria-label]="'Menu'"
     cdkTrapFocus
>
    <cwo-menu-order-tree [title]="'Your Order'" />
</div>